import { MagnifyingGlassIcon } from "@heroicons/react/16/solid";
import { Select, SelectContent, SelectTrigger } from "@moe/oss/ui/select";
import { TagBox } from "@web/components/tag/TagBox";
import { TagInput } from "@web/components/tag/TagInput";
import { TagList } from "@web/components/tag/TagList";
import { useEffect, useRef, useState } from "react";

interface Props {
  onTagSelect?: (tag: string) => void;
}

/**
 * Provides a combobox that allows the users to search for tags
 * On typing "#"" a list of autocompleteable tags will be shown
 */
export function TagCombo({ onTagSelect }: Props) {
  const [open, setOpen] = useState(false);
  const tagInputRef = useRef<HTMLInputElement>(null);
  const [value, setValue] = useState("");

  // Focus the input when the dropdown opens
  useEffect(() => {
    if (open) {
      setTimeout(() => {
        const inputElement = tagInputRef.current?.querySelector("input");
        if (inputElement) {
          inputElement.focus();
        }
      }, 50);
    }
  }, [open]);

  return (
    <Select open={open} onOpenChange={setOpen} value={open ? "adding" : "tags"}>
      <SelectTrigger
        className="text-tx-primary w-30 h-12 justify-start border-none bg-transparent px-0"
        onClick={() => setOpen(true)}
      >
        Tags
      </SelectTrigger>
      <SelectContent ref={tagInputRef} className="w-56">
        <TagBox className="bg-float" value={value} onChange={setValue} mode="combo" onTagSelect={onTagSelect}>
          <div className="flex items-center bg-inherit pl-3">
            <MagnifyingGlassIcon className="text-tx-teriary size-5 shrink-0" />
            <TagInput className="grow border-none bg-inherit" placeholder="Enter tags..." />
          </div>
          <TagList className="border-none" />
        </TagBox>
      </SelectContent>
    </Select>
  );
}
